export default function priceTransform(value) {
    return value / 100000;
}